'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.systemOwnerReview', [])

.factory('systemOwnerReviewService', ['$http', '$q', function ($http, $q) {

    var baseUrl = environment.apiUrl + '/ID/SystemOwner/Review/API';

    var service = {};

    // **** HttpGet
    service.getCurrentPeriod = function () {
        return $http.get(baseUrl + '/Period/Current', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSystemsToReview = function (authLogin) {
        return $http.get(baseUrl +
                         '/BySystemOwner/' + authLogin +
                         '/System/ToReview', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getNextProcessStep = function (authLogin) {
        return $http.get(baseUrl +
                         '/BySystemOwner/' + authLogin +
                         '/ProcessStep/Next', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getStatusReview = function (authLogin) {
        return $http.get(baseUrl +
                         '/BySystemOwner/' + authLogin +
                         '/Status', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Owned - System Ownership

    service.addNewBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl +
                          '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup', {
                              backupEmployeeId: backupEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.removeBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl +
                          '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup/Remove', {
                              backupEmployeeId: backupEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.replaceBackupSystemOwners = function (authLogin, backupEmployees, systems) {
        var backupEmployeeIdList = _.map(backupEmployees, 'EmployeeID');
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl +
                          '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup/Replace', {
                              backupEmployeeIdList: backupEmployeeIdList,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.changePrimarySystemOwner = function (authLogin, primaryEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl +
                          '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Primary', {
                              primaryEmployeeId: primaryEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
